/** ROARDRIVE logotype. The final E is the Tesla-style glyph: three bars, no spine. */
export function Wordmark({ class: cls = 'wordmark' }: { class?: string }) {
  return (
    <div class={cls}>
      Roar
      <span>
        Driv
        <svg class="wordmark__e" viewBox="0 0 62 72" aria-label="E" role="img">
          <rect x="0" y="0" width="62" height="13" />
          <rect x="0" y="29.5" width="50" height="13" />
          <rect x="0" y="59" width="62" height="13" />
        </svg>
      </span>
    </div>
  );
}
